import page from "../sitePages";

export default page;
